module.exports = __webpack_public_path__ + "static/media/feature2assessment.fa69b207.png";